import { cn as e } from "../../lib/utils.js";
import t from "../../_virtual/_@oxc-project_runtime@0.151.0/helpers/esm/objectSpread2.js";
import { iconRegistry as n } from "./icon.js";
import r from "../../assets/icons/facebook.js";
import i from "../../assets/icons/googlemybusiness.js";
import a from "../../assets/icons/instagram.js";
import o from "../../assets/icons/linkedin.js";
import s from "../../assets/icons/other.js";
import c from "../../assets/icons/pinterest.js";
import l from "../../assets/icons/snapchat.js";
import u from "../../assets/icons/threads.js";
import d from "../../assets/icons/tiktok.js";
import f from "../../assets/icons/twitter.js";
import p from "../../assets/icons/youtube.js";
import m from "../../assets/icons/youtube-red-play.js";
import { jsx as h } from "react/jsx-runtime";
//#region src/components/primitives/platform-icon.tsx
var g = [
	"instagram",
	"facebook",
	"twitter",
	"linkedin",
	"googlemybusiness",
	"youtube",
	"pinterest",
	"tiktok",
	"threads",
	"snapchat",
	"other"
], _ = {
	fb: "facebook",
	facebook: "facebook",
	gb: "googlemybusiness",
	gmb: "googlemybusiness",
	google: "googlemybusiness",
	googlebusiness: "googlemybusiness",
	googlemybusiness: "googlemybusiness",
	ig: "instagram",
	instagram: "instagram",
	li: "linkedin",
	ln: "linkedin",
	linkedin: "linkedin",
	ot: "other",
	other: "other",
	pi: "pinterest",
	pinterest: "pinterest",
	sc: "snapchat",
	snapchat: "snapchat",
	th: "threads",
	threads: "threads",
	tt: "tiktok",
	tiktok: "tiktok",
	tw: "twitter",
	twitter: "twitter",
	twitterx: "twitter",
	x: "twitter",
	yt: "youtube",
	youtube: "youtube",
	youtuberedplay: "youtube"
};
function v(e) {
	var t;
	return e ? (t = _[e.toLowerCase().replace(/[^a-z0-9]/g, "")]) == null ? "other" : t : "other";
}
var y = {
	facebook: r,
	googlemybusiness: i,
	instagram: a,
	linkedin: o,
	other: s,
	pinterest: c,
	snapchat: l,
	threads: u,
	tiktok: d,
	twitter: f,
	youtube: p
};
function b({ platform: r, variant: i = "brand", youtubeRedPlay: a, className: o, title: s }) {
	let c = v(r), l = s ? {
		role: "img",
		"aria-label": s
	} : { "aria-hidden": !0 };
	if (i === "mono") return /* @__PURE__ */ h("i", t({
		"data-slot": "platform-icon",
		"data-platform": c,
		className: e("shrink-0", n[c], o)
	}, l));
	let u = c === "youtube" && a ? m : y[c];
	return /* @__PURE__ */ h("img", {
		src: u,
		alt: s == null ? "" : s,
		"aria-hidden": !s || void 0,
		draggable: !1,
		width: 16,
		height: 16,
		"data-slot": "platform-icon",
		"data-platform": c,
		className: e("shrink-0", o)
	});
}
//#endregion
export { b as PlatformIcon, g as SKED_PLATFORMS, v as normalizePlatform };

//# sourceMappingURL=platform-icon.js.map